export default __webpack_public_path__ + "static/media/knowledge-base-icon.841aa389.svg";